import React, { useRef } from 'react'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import { components, useTranslation } from 'cng-web-lib'
import { Grid } from '@material-ui/core'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import EhblCloseMsgKeys from 'src/constants/locale/key/EhblCloseMsg'
import CloseMsgEditForm from './CloseMsgEditForm'
import StatusNotificationListPage from './StatusNotificationListPage'

const { CngTabs } = components

function EditPage({ history, loading, location, onSetLoading, showNotification }) {
  const { id } = useParams()
    const { state } = location
    const { translate } = useTranslation([Namespace.EHBL_CLOSE_MSG])
    const translatedTextsObject = makeTranslatedTextsObject()
    const closeMsgData = useRef(state?.closeMsgData || null)
  
    function makeTranslatedTextsObject() {
        let editCloseMsg = translate(
            Namespace.EHBL_CLOSE_MSG,
            EhblCloseMsgKeys.EDIT_CLOSE_MSG
    )
        let setStatusNotification = translate(
            Namespace.EHBL_CLOSE_MSG,
            EhblCloseMsgKeys.SET_STATUS_NOTIFICATION
        )

        return {
            editCloseMsg,
            setStatusNotification
        }
    }

  return (
      <Grid container spacing={3}>
          <Grid item xs={12}>
              <CngTabs
                  headerColor='primary'
                  tabs={[
                      {
                          tabName: translatedTextsObject.editCloseMsg,
                          tabContent: (
                              <CloseMsgEditForm
                                showNotification={showNotification}
                                  onSetLoading={onSetLoading}
                                  history={history}
                              />
                          )
                      },
                      {
                          tabName: translatedTextsObject.setStatusNotification,
                          tabContent: (
                              <StatusNotificationListPage
                                  history={history}
                                  showNotification={showNotification}
                                  ehblCloseMsgId={id}
                                  onSetLoading={onSetLoading}
                              />
              )
            }
                  ]}
              />
      </Grid>
    </Grid>
  );
}

export default withFormState(EditPage)